export default __webpack_public_path__ + "cd3c5d58a1ffb82a273683889981bf65.png";